import { Box } from "@chakra-ui/react";
import Footer from "./footer";
import Navbar from "./navbar";
import { brandPalette } from "../../../constants/brandPalette";

const PublicLayout = ({ children, color, bg, register = true, type }) => {
  return (
    <Box
      w="100%"
      // h="100%"
      // minH="100vh"
      className="public"
      overflowX="hidden"
      justifyContent="space-between"
      bg={brandPalette.cream}
    >
      <Box h="100px" w="100%">
        <Navbar color={color} bg={bg} register={register} type={type} />
      </Box>
      {children}

      {/* <Footer /> */}
    </Box>
  );
};

export default PublicLayout;
